<template>
  <div id="app">
    <!-- <csteps :progrsesOne="true"></csteps> -->
    <router-view @getToken="refreshToken"/>
  </div>
</template>

<style>
#app {
  	position: relative;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    max-width: 7.6rem;
    margin: 0 auto;
}

</style>
<script>
import csteps from "./components/common/steps"
import {_post, _get} from "@/assets/js/http.js";
import wx from "weixin-js-sdk";
import util from "./assets/js/util.js";
import { checkBrowser,getStorage,setStorage,removeStorage} from "./assets/js/util2.js";


export default {
  data() {
    return {
      
    };
  },
  components: {
    csteps: csteps,
  },
  created() {
   
   
  },
  mounted() {},
  activated() {},
  methods: {
    refreshToken() {
        _get("/accountCenter/v2/auth/refresh?" + util.carsParam({
          token: getStorage('token')
        }, 'get'))
          .then((res) => {
            if (res.data.error === 0) {
              setStorage('token', res.data.data);
              this.getUserId();
            } else if (res.data.error === 11003) {
              let _this = this;
              this.$router.push({path: '/bindAccount'})
            }
          })
      },
    //获取用户中心的个人信息
    getUserId() {
      _get("/accountCenter/v2/user/info?" + util.carsParam({}, 'get'))
        .then(res => {
          if (res.data.error === 0) {
            if (res.data.data && JSON.stringify(res.data.data) !== '{}') {
              setStorage("userCenterInfo", res.data.data, "obj");
            } else {
              Notify({message: '请求失败'});
            }
          } else if (res.data.error === 11002) {
            this.refreshToken();
          } else if (res.data.error === 10007) {
            let curTimeStamp = (Date.parse(new Date()) / 1000),
              timeSpan = res.data.extra - curTimeStamp;
            setStorage('timeSpan', timeSpan);
            this.getUserId();
          } else if (res.data.error === 20014) {
            Notify({message: '请求超时'});
          } else {
            Notify({message: res.data.msg});
          }
        })
    },
   
  },
};
</script>